export type FleetMachineProvider = 'local' | 'aws_ec2' | 'gcp' | 'other'
export type FleetMachineEnvironment = 'local' | 'staging' | 'production'
export type FleetMachineControlMode = 'legacy_ssh' | 'fleet_api'

export const FLEET_MACHINE_PROVIDERS: FleetMachineProvider[] = ['local', 'aws_ec2', 'gcp', 'other']
export const FLEET_MACHINE_ENVIRONMENTS: FleetMachineEnvironment[] = ['local', 'staging', 'production']
export const FLEET_MACHINE_CONTROL_MODES: FleetMachineControlMode[] = ['legacy_ssh', 'fleet_api']

export const FLEET_MACHINE_PROVIDER_LABELS: Record<FleetMachineProvider, string> = {
  local: 'Local',
  aws_ec2: 'AWS EC2',
  gcp: 'Google Cloud',
  other: 'Outro',
}

export const FLEET_MACHINE_ENVIRONMENT_LABELS: Record<FleetMachineEnvironment, string> = {
  local: 'Local',
  staging: 'Staging',
  production: 'Produção',
}

export const FLEET_MACHINE_CONTROL_MODE_LABELS: Record<FleetMachineControlMode, string> = {
  legacy_ssh: 'SSH (legado)',
  fleet_api: 'Fleet API',
}

export interface FleetMachineSummary {
  id: string
  name: string
  slug: string
  provider: FleetMachineProvider
  environment: FleetMachineEnvironment
  control_mode: FleetMachineControlMode
  enabled: boolean
}

export interface FleetMachineRow extends FleetMachineSummary {
  api_base_url: string | null
  instance_url_template: string | null
  metadata: Record<string, unknown>
  api_token_present: boolean
  telemetry_token_present: boolean
  assigned_orgs_count: number
  assigned_workers_count: number
}

export interface FleetMachineTokenFlash {
  machine_id: string
  machine_name: string
  token: string
}

export type FleetMachineTelemetryTokenFlash = FleetMachineTokenFlash
export type FleetMachineApiTokenFlash = FleetMachineTokenFlash
